import SecondaryButton from "../../../CommonButtons/SecondaryButton";
import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../FormatAmount/FormatAmount";
import TickerAnimation from "../../../TickerAnimation";
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("AccountNumber" | "Amount" | "Text")} type
 * @typedef {("lowercase" | "uppercase" | "capitalize")} textCase
 * @param {Object} props
 * @param {String} props.text - Header text
 * @param {String} props.icon - icon for cta button
 * @param {String} props.subText - Subtext
 * @param {String} props.btnText - Text for the cta button
 * @param {type} props.type - type of the header text
 * @param {textCase} props.textCase - text casing of the header text
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.imgColor - Color of icon if needed (var only)
 *
 * @returns {JSX.Element}
 */
const TextWithCTA = ({
  text,
  subText,
  btnText,
  handleFunction,
  isDisabled,
  enabledTextColor,
  enabledBgColor,
  icon,
  type,
  textCase,
  imgColor,
}) => {
  return (
    <div className="flex flex-col gap-y-gap-xs pb-padding-button-s">
      <p
        style={{
          textTransform: textCase,
        }}
        className={`text-font-sm text-text-primary w-full truncate  font-normal px-mobile-padding-l Qmd:px-padding-sm`}
      >
        {type === "Amount" ? (
          <>
            INR <FormatAmount price={Number(text)} />
          </>
        ) : type === "AccountNumber" ? (
          standardAccountNumberFormat(text)
        ) : (
          <TickerAnimation text={text} />
        )}
      </p>
      <div className="w-full  flex pl-mobile-padding-l Qmd:pl-padding-sm justify-between items-center ">
        <p
          className={`text-font-xs w-width-md text-text-secondary transform-none  font-normal`}
        >
          {subText}
        </p>
        <div className="z-z-index-overlay absolute right-0 bottom-[var(--mobile-negative-padding)] Qmd:bottom-[var(--request-padding)]">
          <SecondaryButton
            btnText={btnText}
            handleFunction={(e) => {
              e.stopPropagation();
              handleFunction(e);
            }}
            isDisabled={isDisabled}
            enabledTextColor={enabledTextColor}
            enabledBgColor={enabledBgColor}
            icon={icon}
            imgColor={imgColor}
          />
        </div>
      </div>
    </div>
  );
};

export default TextWithCTA;
